.page { min-height: 100vh; }
.top { display: flex; align-items: center; padding: 24px var(--page-x); border-bottom: var(--border-hair); }
.body { display: flex; flex-direction: column; gap: 24px; max-width: 560px; padding: 40px var(--page-x) 64px; }
.para { margin: 0; font-size: 15px; line-height: 1.6; }
.leave { display: flex; flex-direction: column; gap: 12px; padding-top: 20px; border-top: var(--border-hair); }
.note { margin: 0; font-size: 13px; color: var(--text-secondary); }
.actions { display: flex; flex-wrap: wrap; gap: 12px; }
.policy { align-self: flex-start; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); text-decoration: underline; }
@media (max-width: 639px) {
  .top { padding: 12px var(--page-x); }
  .body { gap: 20px; padding: 24px var(--page-x) 40px; }
  .policy { display: inline-flex; align-items: center; min-height: 44px; }
}
